import React from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { Stack } from "@mui/material";

import BarcodeValueTableRow from "./BarcodeValueTableRow";

const BarcodeValueTableBody = ({
  fields = [],
  remove = () => {},
  move = () => {},
}) => {
  const handleOnDragEnd = (result) => {
    if (!result.destination) return;
    const start = result.source.index;
    const end = result.destination.index;

    move(start, end);
  };

  return (
    <DragDropContext onDragEnd={handleOnDragEnd}>
      <Droppable droppableId="wo-routing">
        {(provided) => (
          <Stack
            position="relative"
            {...provided.droppableProps}
            ref={provided.innerRef}
          >
            {fields?.map((item, idx) => {
              const key = item.id;
              const props = { idx, item, remove };
              return (
                <Draggable key={key} draggableId={key} index={idx}>
                  {(provided) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
                      <BarcodeValueTableRow {...props} />
                    </div>
                  )}
                </Draggable>
              );
            })}
            {provided.placeholder}
          </Stack>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default BarcodeValueTableBody;
